import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCC: CultureInfo = {
  name: 'en-CC',
  displayName: 'English (Cocos [Keeling] Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CC',
  parent: CultureInfoEn
};
